import { queryOptions } from '@tanstack/react-query';
import { getCulpritVehicleCorrectiveImageTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImageTabs/getCulpritVehicleCorrectiveImageTabsFunction';
export const getCulpritVehicleCorrectiveImageTabsOptions = (id: number) =>
  queryOptions({
    queryKey: ['getCulpritVehicleCorrectiveImageTabsOptions', id],
    queryFn: () =>
      getCulpritVehicleCorrectiveImageTabsFunction({
        id: id,
      }),
  });
